/*
jQuery('.form-dealers form [name=land-41] option').each(function() {
	var option = jQuery(this).val();
	console.log('option', option);
	var parts = option.split(':');
	if (parts.length === 2) {
		jQuery(this).attr('value', parts[0]).val(parts[0]).html(parts[1]);
	}
});

import Zipcode from '@wwdev/zipcode';
Zipcode.init({
	scope: '.form-dealers form',
	zipcodeSelector: '[name=postcode-38]',
	streetSelector: '[name=straat-35]',
	streetNumberSelector: '[name=huisnummer-36]',
	townSelector: '[name="woonplaats-39"]',
	countrySelector: '[name=land-41]',
	// defaultSuccess: true,
	// searchZipcodeEnabled: null,
	callback: function(r) {
		console.log(r);
	},
	errorElem: jQuery("<label/>", {
		'class': 'error error_address_lookup',
	}).html('We konden uw combinatie van postcode en huisnummer niet vinden. Klopt deze wél? Ga dan verder.')
});

jQuery('.form-dealers form [name=land-41]').on('change', function() {
	console.log('#', jQuery(this).val());
});
 */